export default {
      id: "vector-usage",
      viewBox: "0 0 30 32",
      url: __webpack_public_path__ + "sprite.svg#vector",
      toString: function () {
        return this.url;
      }
    }